module.exports = __webpack_public_path__ + "img/no-student.7758eab2.svg";